import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatTableModule } from '@angular/material/table'
import { Product } from '../../types/products'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatFormFieldModule } from '@angular/material/form-field'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { RouteService } from '../../services/route.service'
import { ROUTES } from '../../constants/routes'
import { NavbarService } from '../../services/navbar.service'
import { firstValueFrom } from 'rxjs/internal/firstValueFrom'
import { Dialog } from '@angular/cdk/dialog'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { AuthService } from '../../services/auth.service'
import { DialogService } from '../../services/dialog.service'
import { ErrorService } from '../../services/error.service'
import { ProductService } from '../../services/product.service'
import { SpinnerService } from '../../services/spinner.service'
import { WindowService } from '../../services/window.service'
import { ApiError } from '../../types/apiError'
import { TranslationService } from '../../services/translation.service'
@Component({
  selector: 'app-home',
  imports: [
    MatTableModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    RouterModule,
  ],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  route = inject(ActivatedRoute)
  dialog = inject(Dialog)
  dialogService = inject(DialogService)
  routeService = inject(RouteService)
  productService = inject(ProductService)
  spinnerService = inject(SpinnerService)
  errorService = inject(ErrorService)
  windowService = inject(WindowService)
  authService = inject(AuthService)
  navBarService = inject(NavbarService)
  translationService = inject(TranslationService)

  popularProducts: Product[] = []
  displayedColumns: string[] = ['name', 'brand', 'viewAction']

  async ngOnInit(): Promise<void> {
    try {
      this.navBarService.showNavBar()
      this.spinnerService.startSpinner()

      const currentRoute = this.routeService.getUserRoutes(
        ROUTES.VITE_MARKETPLACE.title,
        ROUTES.HOME.path,
      )
      this.routeService.setRoute(currentRoute)

      this.popularProducts = await firstValueFrom(
        this.productService.getPopularProducts(),
      )

      this.spinnerService.stopSpinner()
    } catch (err) {
      this.spinnerService.stopSpinner()
      const apiErr = err as ApiError
      this.errorService.handleErr(this.dialogService, apiErr, this.dialog)
    }
  }
}
